export default "/react/logoLoktar-56a2721b.png";